import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';

export default function TicketsByStatusChart({ tickets, isLoading }) {
  const COLORS = ['#3B82F6', '#FBBF24', '#10B981', '#EF4444', '#A3A3A3'];
  
  // Processar dados para o gráfico
  const getChartData = () => {
    // Se não houver tickets, retornar dados zerados
    if (!tickets || tickets.length === 0) {
      return [
        { name: 'Aberto', value: 0, color: '#3B82F6' },
        { name: 'Em Progresso', value: 0, color: '#FBBF24' },
        { name: 'Resolvido', value: 0, color: '#10B981' },
        { name: 'Fechado', value: 0, color: '#A3A3A3' }
      ];
    }
    
    const statusCounts = tickets.reduce((acc, ticket) => {
      const status = ticket.status;
      acc[status] = (acc[status] || 0) + 1;
      return acc;
    }, {});
    
    const statusLabels = {
      'open': 'Aberto',
      'in_progress': 'Em Progresso',
      'resolved': 'Resolvido',
      'closed': 'Fechado',
      'analysis': 'Em Análise',
      'reopened': 'Reaberto'
    };
    
    const data = Object.keys(statusCounts).map((status, index) => ({
      name: statusLabels[status] || status,
      value: statusCounts[status],
      color: COLORS[index % COLORS.length]
    }));
    
    return data;
  };
  
  const data = getChartData();
  
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }
  
  return (
    <div className="h-64">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip 
            formatter={(value) => [`${value} Chamados`, 'Quantidade']}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}